import { UPDATE_UNAVAILABLE_CONTEXT } from './index';

export const updateUnavailableContextAction = (unavailableContext) => ({
    type: UPDATE_UNAVAILABLE_CONTEXT,
    unavailableContext
});